import React from "react";
import {
  AbsoluteFill,
  Img,
  Series,
  interpolate,
  useCurrentFrame,
} from "remotion";

export type Hyperframe = {
  /** Image source — data URI (data:image/...) or URL. */
  src: string;
  /** How long this frame stays on screen, in frames. */
  durationInFrames: number;
  /** Optional transition hint (only "fade" is special-cased; others = cut). */
  transition?: string;
};

export type HyperframesProps = {
  fps: number;
  frames: Hyperframe[];
};

const FADE = 10; // crossfade length in frames

const Frame: React.FC<{ src: string; dur: number; fade: boolean }> = ({
  src,
  dur,
  fade,
}) => {
  const frame = useCurrentFrame();
  const opacity = fade
    ? interpolate(
        frame,
        [0, FADE, Math.max(FADE, dur - FADE), dur],
        [0, 1, 1, 0],
        { extrapolateLeft: "clamp", extrapolateRight: "clamp" },
      )
    : 1;
  return (
    <AbsoluteFill style={{ opacity }}>
      <Img
        src={src}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    </AbsoluteFill>
  );
};

export const HyperframesImages: React.FC<HyperframesProps> = ({ frames }) => {
  return (
    <AbsoluteFill style={{ backgroundColor: "#000000" }}>
      <Series>
        {frames.map((f, i) => (
          <Series.Sequence
            key={i}
            durationInFrames={Math.max(1, f.durationInFrames)}
          >
            <Frame
              src={f.src}
              dur={Math.max(1, f.durationInFrames)}
              fade={(f.transition ?? "fade") === "fade"}
            />
          </Series.Sequence>
        ))}
      </Series>
    </AbsoluteFill>
  );
};

/**
 * Total video length and fps are derived from the frame list at render time,
 * so the same composition handles any number of frames / any pacing.
 */
export const calcHyperframesMetadata = ({
  props,
}: {
  props: HyperframesProps;
}) => {
  const fps = props.fps && props.fps > 0 ? props.fps : 30;
  const total =
    props.frames?.reduce(
      (acc, f) => acc + Math.max(1, f.durationInFrames),
      0,
    ) || fps;
  return {
    durationInFrames: total,
    fps,
    width: 1920,
    height: 1080,
  };
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
